const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`038b1f0fae518de65200b82b983008d222977b3d37408cd14f6aca0952935218`, `038b1f0fae518de65200b82b983008d222977b3d37408cd14f6aca0952935218`, 1, 53), undefined, true, false, 1));
            }

            getTemplateName() {
                return `038b1f0fae518de65200b82b983008d222977b3d37408cd14f6aca0952935218`;
            }

            getSourceContext() {
                return new this.Source(``, `038b1f0fae518de65200b82b983008d222977b3d37408cd14f6aca0952935218`, ``);
            }
        }],
        [53, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/embed/embed.twig`, `038b1f0fae518de65200b82b983008d222977b3d37408cd14f6aca0952935218`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/embed/embed.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <iframe width="560" height="315" src="https://www.youtube.com/embed/Ty5jtMZXbmk" allowfullscreen></iframe>
  `);
            }

            getTemplateName() {
                return `038b1f0fae518de65200b82b983008d222977b3d37408cd14f6aca0952935218`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `038b1f0fae518de65200b82b983008d222977b3d37408cd14f6aca0952935218`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '038b1f0fae518de65200b82b983008d222977b3d37408cd14f6aca0952935218');

let template = env.loadTemplate('038b1f0fae518de65200b82b983008d222977b3d37408cd14f6aca0952935218');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/embed/demo/video.twig", args: context }
     );
     return rendered;;
};